import { MapPin, MessageCircle, Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const MAP_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.066378417752!2d29.0142668!3d41.0772668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab613861216f9%3A0x6734e56598c17011!2sNispetiye%20Cd%20No%3A9%2C%20Levent%2C%2034330%20Be%C5%9Fikta%C5%9F%2F%C4%B0stanbul!5e0!3m2!1sen!2str!4v1705000000000!5m2!1sen!2str'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="border-t border-white/5 bg-dark-900 pb-10 pt-20">
      <div className="container mx-auto px-4">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <img src="/logo.png" alt="Saatbahane Logo" className="mb-6 h-20 object-contain" loading="lazy" />
            <p className="mb-6 leading-relaxed text-gray-400">{t('contact.about_text')}</p>
          </div>

          <div>
            <h2 className="mb-6 text-sm font-bold uppercase tracking-widest text-gold-500">{t('contact.title')}</h2>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <MapPin className="mt-1 shrink-0 text-white" size={20} aria-hidden="true" />
                <span className="text-gray-300">Nispetiye cd no 9/2,<br />Levent Beşiktaş İstanbul</span>
              </li>
              <li className="flex items-center gap-4">
                <Phone className="shrink-0 text-white" size={20} aria-hidden="true" />
                <a href="tel:+905305000764" className="text-gray-300 transition-colors hover:text-white">+90 530 500 0764</a>
              </li>
              <li>
                <a
                  href="https://wa.me/905305000764"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-lg border border-green-500/20 bg-green-500/10 px-4 py-2 text-green-500 transition-colors hover:bg-green-500/20"
                >
                  <MessageCircle size={18} aria-hidden="true" />
                  <span>WhatsApp Direk Hat</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="mb-6 text-sm font-bold uppercase tracking-widest text-gold-500">Location</h2>
            <div className="group relative h-48 w-full overflow-hidden rounded-lg border border-white/5 bg-dark-800">
              <iframe
                src={MAP_URL}
                title="Saatbahane location"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="grayscale opacity-60 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 md:flex-row">
          <p className="order-2 text-sm text-gray-600 md:order-1">© {new Date().getFullYear()} Saatbahane. {t('footer.rights')}</p>
          <nav className="order-1 flex gap-6 text-sm text-gray-500 md:order-2" aria-label="Legal">
            <Link to="/about" className="transition-colors hover:text-gold-500">{t('footer.about')}</Link>
            <Link to="/privacy" className="transition-colors hover:text-gold-500">{t('footer.privacy')}</Link>
            <Link to="/terms" className="transition-colors hover:text-gold-500">{t('footer.terms')}</Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}

